import { initializeApp } from "firebase/app";
import { getDatabase, ref, push } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyBYSZp2valA_4Qo7kziGJ9L5KaVsXuFdYQ",
  authDomain: "ecosphere-544a6.firebaseapp.com",
  databaseURL: "https://ecosphere-544a6-default-rtdb.firebaseio.com/",
  projectId: "ecosphere-544a6",
  storageBucket: "ecosphere-544a6.appspot.com",
  messagingSenderId: "993724066564",
  appId: "1:993724066564:web:3f1b2ada393ef9a546be51",
  measurementId: "G-YRHGRWQNML",
};

const app = initializeApp(firebaseConfig);
const database = getDatabase(app);

export { database, ref, push };
